import React from 'react';

export default function MyAdsSkeleton({ count = 6 }) {
    const items = Array.from({ length: count });

    return (
        <div className="w-full">
            <div className="grid gap-6 grid-cols-1 pb-5 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 animate-pulse">
                {items.map((_, idx) => (
                    <div key={idx} className="w-full">
                        <div className="rounded-[30px] text-special w-full bg-white border-[1px] border-gray-300 h-max shadow-md flex flex-col justify-between items-end px-1 py-4">

                            {/* status pill */}
                            <div className="flex flex-row gap-2 w-auto items-center mx-5">
                                <div className="flex justify-center gap-2 rounded-lg w-[100px] h-[20px] py-1 px-1 bg-gray-300">
                                    <div className="h-3 w-12 bg-gray-300 rounded" />
                                    <div className="h-3 w-16 bg-gray-300 rounded" />
                                </div>
                            </div>

                            {/* card content mirrors AdsCart structure */}
                            <div className="w-full h-full flex flex-col max-sm:flex-row p-2 md:p-3">
                                {/* image area */}
                                <div className="relative w-full sm:w-full max-sm:w-28 max-sm:h-auto flex-shrink-0 overflow-hidden sm:h-[250px] max-sm:order-2">
                                    <div className="w-full h-full bg-gray-300 sm:rounded-lg max-sm:rounded-none max-sm:rounded-r-lg object-cover" />

                                    <div className="absolute bottom-2 left-2 flex items-center gap-2 bg-black bg-opacity-50 rounded-full px-2 py-1">
                                        <div className="h-3 w-12 bg-gray-300 rounded" />
                                        <div className="h-4 w-4 bg-gray-300 rounded-full" />
                                    </div>
                                </div>

                                {/* text/content area */}
                                <div className="p-3 flex flex-col gap-2 flex-1 max-sm:order-1">
                                    <div className="h-5 w-3/4 bg-gray-300 rounded mb-2" />
                                    <div className="h-4 w-full bg-gray-300 rounded mb-2" />

                                    <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-2 items-start sm:items-center justify-between mt-auto pt-2">
                                        <div className="h-5 w-28 bg-gray-300 rounded-lg" />
                                        <div className="h-4 w-32 bg-gray-300 rounded" />
                                    </div>
                                </div>
                            </div>

                            {/* action buttons area */}
                            <div className="w-full mt-2 sm:mt-0 px-5 gap-2 flex justify-center">
                                <div className="w-[40%] h-7 bg-gray-300 rounded-full" />
                                <div className="w-[55%] h-7 bg-gray-300 rounded-full" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}



